import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { IMG, waLink, WA } from "../../data/content";
import { Overline, GoldDivider } from "./Ornament";
import { WhatsappIcon } from "./Header";
import { EASE } from "../../lib/motion";

const perks = [
  { en: "Deity", hi: "विग्रह" },
  { en: "Size", hi: "आकार" },
  { en: "Fabric", hi: "कपड़ा" },
  { en: "Colour", hi: "रंग" },
  { en: "Design", hi: "डिज़ाइन" },
  { en: "Occasion", hi: "अवसर" },
];

export const CustomDress = () => {
  const { t } = useLang();

  return (
    <section id="custom" data-testid="custom-section" className="relative bg-velvet grain py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Visual */}
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: EASE }}
          className="relative order-2 lg:order-1"
        >
          <div className="overflow-hidden rounded-t-[160px] rounded-b-lg border border-gold/30">
            <img
              src={IMG.customAtelier}
              alt="Bespoke deity poshak in progress with gold zardozi embroidery, thread and marigold"
              className="w-full h-[420px] sm:h-[560px] object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 rounded-t-[160px] rounded-b-lg ring-1 ring-inset ring-gold/20" />
        </motion.div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <Overline dark>{t(S.custom.overline)}</Overline>
          <h2 className="mt-4 font-serif font-light text-ivory leading-[1.1] tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            {t(S.custom.heading)}
          </h2>
          <GoldDivider className="mt-6 !justify-start" />
          <p className="mt-5 text-ivory/70 text-sm sm:text-base leading-relaxed max-w-lg">{t(S.custom.sub)}</p>

          {/* Options */}
          <div className="mt-8 flex flex-wrap gap-2.5">
            {perks.map((p) => (
              <span
                key={p.en}
                className="inline-flex items-center gap-2 rounded-full border border-gold/30 px-4 py-2 text-xs font-cinzel tracking-wide text-goldlight"
              >
                <span className="w-1 h-1 rounded-full bg-gold" />
                {t(p)}
              </span>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={waLink(WA.custom)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="custom-whatsapp"
              className="group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-medium text-burgundy hover:bg-goldlight hover:-translate-y-0.5 transition-all duration-300"
            >
              <WhatsappIcon className="w-4 h-4" />
              {t(S.custom.cta)}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
